"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _SelectInline = _interopRequireDefault(require("@commerce-ui/core2/SelectInline"));
var _Grid = _interopRequireDefault(require("@commerce-ui/core2/Grid"));
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultProps = {
  minifiedVersion: false,
  sameLabelForOptions: false
};
var OptionsSelector = function OptionsSelector(props) {
  var options = props.options,
    _props$minifiedVersio = props.minifiedVersion,
    minifiedVersion = _props$minifiedVersio === void 0 ? defaultProps.minifiedVersion : _props$minifiedVersio,
    colorSquare = props.colorSquare,
    pill = props.pill,
    selectNative = props.selectNative,
    formControl = props.formControl,
    gridWidth = props.gridWidth,
    _props$sameLabelForOp = props.sameLabelForOptions,
    sameLabelForOptions = _props$sameLabelForOp === void 0 ? defaultProps.sameLabelForOptions : _props$sameLabelForOp;
  var translations = {
    size: (0, _langLibrary["default"])("size"),
    color: (0, _langLibrary["default"])("color"),
    capacity: (0, _langLibrary["default"])("capacity"),
    diameter: (0, _langLibrary["default"])("diameter"),
    material: (0, _langLibrary["default"])("material"),
    shape: (0, _langLibrary["default"])("shape"),
    height: (0, _langLibrary["default"])("height"),
    width: (0, _langLibrary["default"])("width"),
    length: (0, _langLibrary["default"])("length"),
    depth: (0, _langLibrary["default"])("depth"),
    number_of_people: (0, _langLibrary["default"])("number of people"),
    available_versions: (0, _langLibrary["default"])("available versions")
  };
  var singlePickerStyle = {
    mb: "s7",
    width: "100%"
  };
  return __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "column"
    }
  }, options.map(function (option) {
    return option.values.length > 1 && __jsx(_Box["default"], {
      sx: option.id === "color_trade_name" ? _objectSpread(_objectSpread({}, singlePickerStyle), {}, {
        order: "1"
      }) : _objectSpread(_objectSpread({}, singlePickerStyle), {}, {
        order: "2"
      }),
      key: option.id
    }, __jsx(_Box["default"], {
      sx: !minifiedVersion && {
        pb: "s5"
      }
    }, option.id === "color_trade_name" && /*#__PURE__*/_react["default"].cloneElement(formControl, {
      label: sameLabelForOptions ? translations.available_versions : translations.color
    }, __jsx(_SelectInline["default"], option.selectProps, function (_ref) {
      var selectableProps = _ref.selectableProps;
      selectableProps.filter(function (selected) {
        return Array.isArray(selected.option.image);
      }).forEach(function (selected) {
        selected.option.image = selected.option.product.optionPickerImage;
      });
      return __jsx(_Grid["default"], {
        minItemWidth: gridWidth !== null && gridWidth !== void 0 ? gridWidth : 60,
        gap: 3
      }, selectableProps.map(function (props) {
        return /*#__PURE__*/_react["default"].cloneElement(colorSquare, _objectSpread({}, props));
      }));
    })), option.id === "size" && !minifiedVersion && /*#__PURE__*/_react["default"].cloneElement(formControl, {
      label: sameLabelForOptions ? translations.available_versions : translations.size
    }, __jsx(_SelectInline["default"], option.selectProps, function (_ref2) {
      var selectableProps = _ref2.selectableProps;
      return __jsx(_Grid["default"], {
        minItemWidth: 100,
        gap: 8
      }, selectableProps.map(function (props) {
        return /*#__PURE__*/_react["default"].cloneElement(pill, _objectSpread({}, props));
      }));
    })), option.id !== "color_trade_name" && option.id !== "size" && /*#__PURE__*/_react["default"].cloneElement(selectNative, _objectSpread(_objectSpread({}, option.selectProps), {}, {
      label: option.name === "capacity" ? "".concat(translations[option.name], " (l)") : translations[option.name],
      placeholder: sameLabelForOptions ? "" : translations[option.name]
    }))));
  }));
};
var _default = OptionsSelector;
exports["default"] = _default;